module.exports = __webpack_public_path__ + "img/faq4.63b18c0f.svg";